module.exports = __webpack_public_path__ + "media/images/lookup-table-covid19-314a2b46c4fbd40313f0751058d269c9.png";